import React, { useState, useRef, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
// import { Link } from 'react-router-dom'
// import ReactGA from 'react-ga'

import styles from '../component-styles/get-started.module.scss'
import Button from './button'
import {
  onBoardingV2FormValidation,
  onBoardingV2FormValidationPassword,
} from '../helpers/forms'
import {
  createNewClientAsync,
  authenticateAsync,
  resetLoginAttemptFailAsync,
  resetOnboardingCreateUserFailedAsync,
} from '../store/actions'
import DisplayError from './display-error'
import Input from './input'
import GoogleButton from './login-button-google'
import MicrosoftButton from './login-button-microsoft'

export default function GetStarted(): React.ReactElement {
  const dispatch = useDispatch()
  const history = useHistory()
  const errorRef = useRef<HTMLSpanElement>(null)
  const { createdBillingUser, onError } = useSelector(
    (s: any): any => s.onboarding,
  )
  const { login } = useSelector((state: any): any => state)
  const { authenticated } = useSelector((s: any): any => s.user)
  const [email, setEmail] = useState('')
  const [fName, setFName] = useState('')
  const [lName, setLName] = useState('')
  // const [phoneNum, setPhoneNum] = useState('')
  const [organisation, setOrganisation] = useState('')
  const [terms, setTerms] = useState(false)
  const [offers, setOffers] = useState(false)
  const [password, setPassword] = useState('')
  const [passwordConfirmation, setPasswordConfirmation] = useState('')
  const initialError = { message: '', attempts: 0 }
  const [error, setError] = useState(initialError)
  const [secondStep, setSecondStep] = useState(false)

  const handleError = (message: string): void =>
    setError((err: any): any => ({ message, attempts: err.attempts + 1 }))

  useEffect(() => {
    dispatch(resetLoginAttemptFailAsync())
    dispatch(resetOnboardingCreateUserFailedAsync())
    setError(initialError)
  }, [])

  useEffect((): void => {
    if (createdBillingUser) {
      // dispatch(getUserDetailsAsync())
      dispatch(authenticateAsync({ password, email }))
      // history.push('/track/create-campaign-codes')
    }
    // eslint-disable-next-line
  }, [createdBillingUser])

  useEffect((): void => {
    if (authenticated) {
      // ReactGA.event({
      //   category: 'New account created',
      //   action: 'User created a new account',
      // })
      history.push('/welcome')
    }
    // eslint-disable-next-line
  }, [authenticated])

  useEffect((): void => {
    if (onError) {
      handleError(onError)
      if (errorRef && errorRef.current) {
        errorRef.current.scrollIntoView({ behavior: 'smooth' })
      }
    }
  }, [onError])

  useEffect((): void => {
    if (error.message !== '' && errorRef && errorRef.current) {
      errorRef.current.scrollIntoView({ behavior: 'smooth' })
    }
  }, [error])

  const handleSubmit = (e: any): void => {
    e.preventDefault()
    if (!secondStep) {
      const validFirstStep = onBoardingV2FormValidation(
        {
          fName,
          lName,
          email,
          organisation,
          terms,
        },
        handleError,
      )

      if (validFirstStep) {
        setSecondStep(true)
        setError({ message: '', attempts: 0 })
      }
    } else {
      const validSecondStep = onBoardingV2FormValidationPassword(
        {
          password,
          passwordConfirmation,
        },
        handleError,
      )

      if (validSecondStep) {
        dispatch(
          createNewClientAsync({
            fName,
            lName,
            email,
            // phoneNum,
            organisation,
            passW: password,
            signUpMethod: 'password',
            acceptedMarketing: offers,
          }),
        )
      }
    }
  }

  const state = {
    fName,
    lName,
    email,
    // phoneNum,
    organisation,
    acceptedMarketing: offers,
  }

  if (secondStep) {
    return (
      <div className={styles.ssoWrapper}>
        <form onSubmit={handleSubmit}>
          <h1>Create new account</h1>
          <p>How would you like to sign up?</p>
          <span className={styles.spacer} ref={errorRef} />
          <DisplayError
            className={styles.errorMessage}
            attempts={error.attempts}
          >
            {error.message}
          </DisplayError>
          <div>
            <GoogleButton login={login} state={state} action="create" />
            <MicrosoftButton login={login} state={state} action="create" />

            <div className={styles.divider} />
            <h2>Or sign up with password</h2>
            <Input
              name="password"
              type="password"
              autoComplete="new-password"
              label="Password"
              value={password}
              onChange={(e: React.ChangeEvent<HTMLInputElement>): void => {
                const { value: val } = e.target as HTMLInputElement
                setPassword(val)
              }}
              required
            />

            <Input
              name="passwordConfirmation"
              type="password"
              autoComplete="new-password"
              label="Confirm password"
              value={passwordConfirmation}
              onChange={(e: React.ChangeEvent<HTMLInputElement>): void => {
                const { value: val } = e.target as HTMLInputElement
                setPasswordConfirmation(val)
              }}
              required
            />
          </div>
          <Button submit>Sign up</Button>
        </form>
      </div>
    )
  }

  return (
    <div className={styles.ssoWrapper}>
      <form onSubmit={handleSubmit}>
        <h1>Create new account</h1>
        <p>Make and manage campaign links the easy way.</p>
        <span className={styles.spacer} ref={errorRef} />
        <DisplayError className={styles.errorMessage} attempts={error.attempts}>
          {error.message}
        </DisplayError>
        <div>
          <Input
            name="fName"
            type="fName"
            label="First name"
            value={fName}
            onChange={(e: React.ChangeEvent<HTMLInputElement>): void => {
              const { value: val } = e.target as HTMLInputElement
              setFName(val)
            }}
            required
          />

          <Input
            name="lName"
            type="lName"
            label="Last name"
            value={lName}
            onChange={(e: React.ChangeEvent<HTMLInputElement>): void => {
              const { value: val } = e.target as HTMLInputElement
              setLName(val)
            }}
            required
          />

          <Input
            name="email"
            type="email"
            label="Email"
            value={email}
            onChange={(e: React.ChangeEvent<HTMLInputElement>): void => {
              const { value: val } = e.target as HTMLInputElement
              setEmail(val)
            }}
            required
          />

          <Input
            name="organisation"
            value={organisation}
            label="Organisation"
            onChange={(e: React.ChangeEvent<HTMLInputElement>): void => {
              const { value: val } = e.target as HTMLInputElement
              setOrganisation(val)
            }}
            required
          />

          {/* <Input
            name="phone"
            value={phoneNum}
            label="Phone number (optional)"
            onChange={(e: React.ChangeEvent<HTMLInputElement>): void => {
              const { value: val } = e.target as HTMLInputElement
              setPhoneNum(val)
            }}
          /> */}

          <Input
            className={styles.checkbox}
            name="offers"
            type="checkbox"
            checked={offers}
            onChange={(): void => setOffers((t: boolean): boolean => !t)}
            label={
              <>
                Receive Uplifter{' '}
                <a
                  href="/terms-of-service.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  updates and offers
                </a>
                .
              </>
            }
          />
          <Input
            className={styles.checkbox}
            name="terms"
            type="checkbox"
            checked={terms}
            onChange={(): void => setTerms((t: boolean): boolean => !t)}
            label={
              <>
                I accept the{' '}
                <a
                  href="/terms-of-service.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Terms of Service
                </a>{' '}
                and{' '}
                <a
                  href="/privacy-statement.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Privacy Policy
                </a>
                .
              </>
            }
          />
          <Button submit>Create new account</Button>
          <div className={styles.divider} />
          <h2>Already have an account?</h2>
          <Button type="flatGrey" to="/login">
            Log in here
          </Button>
        </div>
      </form>
    </div>
  )
}
